module.exports = __webpack_public_path__ + "img/detail9.47d8149a.png";